export const STORY_CANON = {
  title: "Taronno's Love",
  subtitle: "A story ten years in the making.",
  heroine: "Labonno",
  hero: "Talha",
  level1: {
    year: "2011",
    subtitle: "The Rooftop",
    dialogueEmily: "Which school do you go to? And what class are you in?",
    dialogueTalha: "Class four, MUBC school.",
    talhaNeverTurns: true
  },
  level2: {
    date: "September 20, 2016",
    time: "2:25 PM",
    password: "rooftop",
    firstChat: [
      {
        id: 1,
        sender: "Labonno",
        text: "Hii talha",
        time: "2:25 PM",
        isTalha: false
      },
      {
        id: 2,
        sender: "Talha",
        text: "Hii 🙂",
        time: "2:25 PM",
        isTalha: true
      }
    ]
  },
  level3: {
    year: "2026",
    subtitle: "The Queen and Her Knight",
    requiredQuote: "We are the only two people on this earth, and that's all that matters.",
    callbackRooftop: {
      talha: "You know, there's something I've been meaning to do for a very long time.",
      emily: "What's that?",
      talhaTurn: "Look at you properly.",
      emilyReaction: "Only took you fifteen years."
    }
  },
  montageYears: [
    { year: "2016", title: "The First Hello", desc: "A simple greeting that reopened destiny after five quiet years." },
    { year: "2017", title: "Midnight Talks", desc: "Endless conversations into the early dawn, learning every secret habit." },
    { year: "2018", title: "Growing Closer", desc: "Sharing jokes, playlists, and unspoken comfort through every storm." },
    { year: "2019", title: "Through Every Distance", desc: "Miles felt like inches whenever a message arrived on screen." },
    { year: "2020", title: "Anchor in the World", desc: "When the whole world paused, we held each other steadfast." },
    { year: "2021", title: "Five Years of Us", desc: "Realizing that five years felt like a single golden heartbeat." },
    { year: "2022", title: "Unshakable Dreams", desc: "Building promises, future homes, and quiet unyielding loyalty." },
    { year: "2023", title: "Side by Side", desc: "Facing every test, turning every obstacle into our shared path." },
    { year: "2024", title: "In Love and Purpose", desc: "Our laughter deepening into an eternal, gentle bond." },
    { year: "2025", title: "On the Threshold", desc: "Knowing without a shadow of doubt: it has always been you." },
    { year: "2026", title: "Ten Years and Counting", desc: "A queen and her knight. Together forever." }
  ]
};
